export default {
	data: function() {
		return {
			show: false,
			trafficLayer: null
		};
	},
	created() {
		
	},
	methods: {
		loadControls(map) {
			this.$nextTick(() => {
				var self = this;
				var controlDiv = document.createElement("div");
				var firstChild = document.getElementById("div-view-traffic");
				firstChild.style.backgroundColor = "#fff";
				firstChild.style.border = "none";
				firstChild.style.outline = "none";
				firstChild.style.width = "28px";
				firstChild.style.height = "28px";
				firstChild.style.borderRadius = "2px";
				firstChild.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
				firstChild.style.cursor = "pointer";
				firstChild.style.marginRight = "20px";
				firstChild.style.padding = "0px";
				controlDiv.appendChild(firstChild);
				var secondChild = document.createElement("div");
				secondChild.style.margin = "3px";
				secondChild.style.width = "25px";
				secondChild.style.height = "28px";
				secondChild.style.backgroundImage = "url(/icon-start-traffic.png)";
				secondChild.style.backgroundSize = "25px 23px";
				secondChild.style.backgroundPosition = "0px 0px";
				secondChild.style.backgroundRepeat = "no-repeat";
				secondChild.title = "Traffico";
				secondChild.id="traffic-child-div";
				firstChild.appendChild(secondChild);
				window.google.maps.event.addListener(map.$mapObject, "center_changed", function() {
					secondChild.style["background-position"] = "0 0";
				});

				firstChild.addEventListener("click", function() {
					self.show = !self.show;
					if (self.show) {
						if (self.trafficLayer == null) {
							self.trafficLayer = new google.maps.TrafficLayer();
						}
						self.trafficLayer.setMap(map.$mapObject);
						secondChild.style.backgroundImage = "url(/icon-stop-traffic.png)";
					}
					else {
						self.trafficLayer.setMap(null);
						secondChild.style.backgroundImage = "url(/icon-start-traffic.png)";
					}
				});
				controlDiv.index = 1;
				map.$mapObject.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
			});
		}
	},
	computed: {}
};
